var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2132 8.7771C20.1496 8.57161 19.9802 8.42185 19.7762 8.39082L14.0474 7.51811L11.4853 2.07612C11.3941 1.8824 11.2059 1.75977 10.9998 1.75977C10.7937 1.75977 10.6055 1.8824 10.5143 2.07612L7.95209 7.51811L2.22331 8.39082C2.01942 8.42185 1.84996 8.57161 1.78629 8.77706C1.72258 8.98256 1.77571 9.2081 1.9233 9.35889L6.06858 13.5949L5.09015 19.5763C5.05529 19.7892 5.13881 20.0044 5.30552 20.1314C5.39984 20.2032 5.51155 20.2398 5.6238 20.2398C5.70999 20.2398 5.79647 20.2182 5.87566 20.1746L10.9998 17.3505L16.1236 20.1745C16.3061 20.2751 16.5271 20.2583 16.6938 20.1314C16.8605 20.0044 16.9441 19.7892 16.9093 19.5762L15.9305 13.5949L20.0762 9.35885C20.2238 9.2081 20.277 8.98256 20.2132 8.7771Z",
    fill: "#0741AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRating);
export default __webpack_public_path__ + "static/media/StarRating.100e113e.svg";
export { ForwardRef as ReactComponent };